export const news =[
    {
        noticia: "https://sekailist.vercel.app//news1.PNG",
        link: "https://www.intoxianime.com/2023/03/dead-mount-death-isekai-do-autor-de-durarara-ganha-trailer-com-op-e-data-de-estreia/"
    },
    {
        noticia: "https://sekailist.vercel.app//news2.PNG",
        link: "https://www.intoxianime.com/2023/03/dr-stone-3o-temporada-ganha-trailer-completo-com-op-e-data-de-estreia/"
    },
    {
        noticia: "https://sekailist.vercel.app//news3.PNG",
        link: "https://www.intoxianime.com/2023/03/boushoku-no-berserk-anime-sobre-protagonista-devorador-de-almas-ganha-teaser-e-janela-de-estreia/"
    },
    {
        noticia: "https://sekailist.vercel.app//news4.PNG",
        link: "https://www.intoxianime.com/2023/03/yamada-kun-to-lv999-comedia-romantica-entre-jogadores-de-mmo-ganha-trailer-com-op/"
    }
]
export const noticias =[
    {
        noticia: "https://sekailist.vercel.app//news0.PNG",
        link: "https://www.intoxianime.com/2023/03/guia-de-novos-animes-de-abril-2023/",
        id: 1
    },
    {
        noticia: "https://sekailist.vercel.app//news1.PNG",
        link: "https://www.intoxianime.com/2023/03/dead-mount-death-isekai-do-autor-de-durarara-ganha-trailer-com-op-e-data-de-estreia/",
        id: 2
    },
    {
        noticia: "https://sekailist.vercel.app//news2.PNG",
        link: "https://www.intoxianime.com/2023/03/dr-stone-3o-temporada-ganha-trailer-completo-com-op-e-data-de-estreia/",
        id: 3
    },
    {
        noticia: "https://sekailist.vercel.app//news3.PNG",
        link: "https://www.intoxianime.com/2023/03/boushoku-no-berserk-anime-sobre-protagonista-devorador-de-almas-ganha-teaser-e-janela-de-estreia/",
        id: 4
    },
    {
        noticia: "https://sekailist.vercel.app//news4.PNG",
        link: "https://www.intoxianime.com/2023/03/yamada-kun-to-lv999-comedia-romantica-entre-jogadores-de-mmo-ganha-trailer-com-op/",
        id: 5
    },
    {
        noticia: "https://sekailist.vercel.app//news5.PNG",
        link: "https://www.intoxianime.com/2023/03/tonikaku-kawaii-2o-temporada-ganha-trailer-com-op-e-data-de-estreia/",
        id: 6
    },
    {
        noticia: "https://sekailist.vercel.app//news6.PNG",
        link: "https://www.intoxianime.com/2023/02/rumor-kage-no-jitsuryokusha-2o-temporada-deve-estrear-em-outubro/",
        id: 7
    },
    {
        noticia: "https://sekailist.vercel.app//news7.PNG",
        link: "https://www.intoxianime.com/2023/03/guia-de-novos-animes-de-abril-2023/",
        id: 8
    },
    {
        noticia: "https://sekailist.vercel.app//news8.PNG",
        link: "https://www.intoxianime.com/2023/03/dead-mount-death-isekai-do-autor-de-durarara-ganha-trailer-com-op-e-data-de-estreia/",
        id: 9
    },
    {
        noticia: "https://sekailist.vercel.app//news9.PNG",
        link: "https://www.intoxianime.com/2023/03/dr-stone-3o-temporada-ganha-trailer-completo-com-op-e-data-de-estreia/",
        id: 10
    },
    {
        noticia: "https://sekailist.vercel.app//news3.PNG",
        link: "https://www.intoxianime.com/2023/03/boushoku-no-berserk-anime-sobre-protagonista-devorador-de-almas-ganha-teaser-e-janela-de-estreia/",
        id: 11
    },
    {
        noticia: "https://sekailist.vercel.app//news4.PNG",
        link: "https://www.intoxianime.com/2023/03/yamada-kun-to-lv999-comedia-romantica-entre-jogadores-de-mmo-ganha-trailer-com-op/",
        id: 12
    },
]
